import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=b08c1db6&scoped=true&"
import script from "./UserItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=b08c1db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08c1db6",
  null
  
)

export default component.exports